import type { ComponentProps } from 'react';
import { forwardRef } from 'react';
import type { StyledInputTextProps } from './StyledInputText';
import { StyledInputText } from './StyledInputText';
import { inputStyle } from './inputStyle';

type InputProps = ComponentProps<'input'>;

export interface BaseInputTextProps extends Omit<StyledInputTextProps<InputProps>, 'as'> {
  type?: InputProps['type'];
  /** @deprecated Please set width on container, not as a prop of an input */
  width?: never;
}

export type InputTextProps = BaseInputTextProps & InputProps;

const InputTextForwardRef = forwardRef<HTMLInputElement, InputTextProps>(({ type = 'text', ...props }, ref) => {
  return <StyledInputText as="input" asRef={ref} type={type} {...props} />;
});

/** @deprecated use InputText from kitt-universal instead */
export const InputText: typeof InputTextForwardRef & {
  inputStyle: typeof inputStyle;
  StyledInputText: typeof StyledInputText;
} = Object.assign(InputTextForwardRef, { inputStyle, StyledInputText });
